// extracted by mini-css-extract-plugin
export default {"question":"Question_question__Pp1IN","qtitle":"Question_qtitle__YJeMk"};